<template>
    <div class="main">
        <global-tag>
            <span slot="title"> 房屋信息登记</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="户口：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.residence"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label="房屋类型：">
                                        <el-select
                                            style="width: 100%"
                                            v-model="queryInfo.housingType"
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                label="商住房"
                                                value="1"
                                            ></el-option>
                                            <el-option
                                                label="自建房"
                                                value="2"
                                            ></el-option>
                                            <el-option
                                                label="其他"
                                                value="3"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch" class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                    class="button openBtns"
                    size="mini"
                    @click="addServices('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    class="button downOutBtns"
                    size="mini"
                    @click="createExcel"
                    >导出</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
                    <span>导入</span>
                </label>
                <el-button
                    type="danger"
                    class="button"
                    size="mini"
                    @click="deleteItem"
                    >删除</el-button
                >
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false"  class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox label="户名"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="房屋类别"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="房屋性质"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="房屋用途"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="出租用途"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="租住类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="房屋结构"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="隐患类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="房屋间数"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="房屋面积"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="房屋产权证号"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="托管人姓名"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="托管人身份证号码"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="是否为空置房"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="标准地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="备注"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="点位坐标"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                ref="multipleTable"
                @row-click="openDetails"
                @selection-change="handleSelectionChange"
                :header-cell-style="{
                    background: '#e6e6e6',
                    color: '#000',
                }"
                border
            >
                <el-table-column
                    type="selection"
                    width="55"
                    @selection-change="handleSelectionChange"
                ></el-table-column>
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="户名"
                    align="center"
                    prop="residence"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '户名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="房屋类别"
                    align="center"
                    prop="housingType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '房屋类别'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.housingType == 1">商住房</span>
                        <span v-if="scope.row.housingType == 2">自建房</span>
                        <span v-if="scope.row.housingType == 3">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="房屋性质"
                    align="center"
                    prop="housingNature"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '房屋性质'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.housingNature == 1"
                            >私有房产</span
                        >
                        <span v-if="scope.row.housingNature == 2"
                            >集体所有房产</span
                        >
                        <span v-if="scope.row.housingNature == 3"
                            >固有房产</span
                        >
                        <span v-if="scope.row.housingNature == 4">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="房屋用途"
                    align="center"
                    prop="housingPurpose"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '房屋用途'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.housingPurpose == 1"
                            >商住两用</span
                        >
                        <span v-if="scope.row.housingPurpose == 2">办公</span>
                        <span v-if="scope.row.housingPurpose == 3">厂房</span>
                        <span v-if="scope.row.housingPurpose == 4">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="出租用途"
                    align="center"
                    prop="leasePurpose"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '出租用途'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.leasePurpose == 1">住房</span>
                        <span v-if="scope.row.leasePurpose == 2">商用</span>
                        <span v-if="scope.row.leasePurpose == 3">厂房</span>
                        <span v-if="scope.row.leasePurpose == 4">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="租住类型"
                    align="center"
                    prop="rentLiveType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '租住类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.rentLiveType == 1">住房</span>
                        <span v-if="scope.row.rentLiveType == 2">商用</span>
                        <span v-if="scope.row.rentLiveType == 3">厂房</span>
                        <span v-if="scope.row.rentLiveType == 4">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="房屋结构"
                    align="center"
                    prop="housingStructure"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '房屋结构'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.housingStructure == 1"
                            >钢筋混凝土</span
                        >
                        <span v-if="scope.row.housingStructure == 2"
                            >钢机构</span
                        >
                        <span v-if="scope.row.housingStructure == 3"
                            >木机构</span
                        >
                        <span v-if="scope.row.housingStructure == 4"
                            >砖木机构</span
                        >
                        <span v-if="scope.row.housingStructure == 5"
                            >其他机构</span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="隐患类型"
                    align="center"
                    prop="dangerType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '隐患类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.dangerType == 0">无</span>
                        <span v-if="scope.row.dangerType == 1">火灾隐患</span>
                        <span v-if="scope.row.dangerType == 2">治安隐患</span>
                        <span v-if="scope.row.dangerType == 3"
                            >矛盾纠纷隐患</span
                        >
                        <span v-if="scope.row.dangerType == 4"
                            >疾病传染隐患</span
                        >
                        <span v-if="scope.row.dangerType == 5">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="房屋间数"
                    align="center"
                    prop="housingNumber"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '房屋间数'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="房屋面积"
                    align="center"
                    prop="housingMeasure"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '房屋面积'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="房屋产权证号"
                    align="center"
                    prop="propertyNumber"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '房屋产权证号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="登记日期"
                    align="center"
                    prop="loginDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '登记日期'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="托管人姓名"
                    align="center"
                    prop="name"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '托管人姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="托管人身份证号码"
                    align="center"
                    prop="idCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '托管人身份证号码'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="是否为空置房"
                    align="center"
                    prop="vacantFlag"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '是否为空置房'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.vacantFlag == 0">否</span>
                        <span v-if="scope.row.vacantFlag == 1">是</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="标准地址"
                    align="center"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '标准地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="备注"
                    align="center"
                    prop="remark"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '备注'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="点位坐标"
                    align="center"
                    prop="longitude"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '点位坐标'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span
                            >{{ scope.row.longitude }},{{
                                scope.row.latitude
                            }}</span
                        >
                    </template>
                </el-table-column>

                <el-table-column
                    label="创建时间"
                    align="center"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑时间"
                    align="center"
                    prop="updateDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    prop="createPersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑人"
                    align="center"
                    prop="updatePersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    width="240px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div>
                            <span
                                @click="addServices('详情', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看</span
                            >
                             <span
                                @click="addServices('编辑', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >编辑</span
                            >
                            <span
                                @click="seeMap(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >地图定位</span
                            >
                            <!-- <span
                                @click="goSee(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >走访处理</span
                            > -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <add-service
            v-if="serviceState"
            :openData="serviceInfo"
            @cancleService="cancleService"
        ></add-service>
        <sign-list
            v-if="signState"
            :openData="signInfo"
            @cancleService="cancleService"
        ></sign-list>
        <map-info
            v-if="mapState"
            :openData="mapInfo"
            @cancleService="cancleService"
        ></map-info>
    </div>
</template>
<script>
import globalTag from "../../../components/globalTag"
import addService from "./components/addService"
import mapInfo from "@/components/mapInfo"
import signList from "./components/signList"
import request from "@/utils/request.js"
export default {
    name: "serviceMange",
    inject: ["reload"], //注入
    components: { globalTag, addService, signList, mapInfo },
    data() {
        return {
            selectedData: [],
            mapState: false,
            mapInfo: {},
            signState: false,
            signInfo: {},
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            tableData: [],
            queryInfo: {},
            serviceState: false,
            serviceInfo: {},

            tempTableChekbox: [
                "序号",
                "户名",
                "房屋类别",
                "房屋性质",
                "房屋用途",
                "出租用途",
                "租住类型",
                "房屋结构",
                "隐患类型",
                "房屋间数",
                "房屋面积",
                "房屋产权证号",
                "登记日期",
                "托管人姓名",
                "托管人身份证号码",
                "是否为空置房",
                "标准地址",
                "备注",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "户名",
                "房屋类别",
                "房屋性质",
                "房屋用途",
                "出租用途",
                "租住类型",
                "房屋结构",
                "隐患类型",
                "房屋间数",
                "房屋面积",
                "房屋产权证号",
                "登记日期",
                "托管人姓名",
                "托管人身份证号码",
                "是否为空置房",
                "标准地址",
                "备注",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 查看定位
seeMap(row) {
  this.mapState = true
  this.mapInfo = row
  this.mapInfo.state = true
},
        // 走访处理
        goSee(row) {
            this.signState = true
            this.signInfo = { id: row.id, state: true }
        },

        //服务时间发生变化
        recTimeChange(val) {
            console.log(val)
            if (!val) return
            this.queryInfo.beginTime = val[0]
            this.queryInfo.endTime = val[1]
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
            }
            this.$http
                .request({
                    url: "/ypt/admin/housingRegistration/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        if (res.content.list.length > 0) {
                            res.content.list.forEach((item) => {
                                item.hasChagned =
                                    Number(item.counts) - Number(item.stock)
                            })
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },

        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 取消新增、编辑、查看
        cancleService(state) {
            this.serviceState = false
            this.mapState = false
            this.signState = false
            if (state == true) {
                this.getList()
            }
        },

        // 新增\编辑\查看
        addServices(title, row) {
            this.serviceState = true
            this.openData = {}
            this.serviceInfo = {}
            this.serviceInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
        },

        // 页面刷新
        reset() {
            this.reload()
        },
        // 搜索
        querySearch() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                residence: this.queryInfo.residence,
                housingType: this.queryInfo.housingType,
            }
            this.$http
                .request({
                    url: "/ypt/admin/housingRegistration/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        //导出excel
        createExcel() {
            this.request2({
                url: "/ypt/admin/housingRegistration/info/downloadExcel",
                method: "POST",
                excel: true,
                data: {},
                responseType: "blob",
            }).then((res) => {
                console.log("adsasd")
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "房屋信息.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/housingRegistration/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
        handleSelectionChange(rows) {
            this.multipleSelection = rows
        },
        handleSelectionChange(data) {
            this.selectedData = data
            console.log(this.selectedData)
        },
        // 行点击选中
        openDetails(row, event, column, cell) {
            this.$refs.multipleTable.toggleRowSelection(row)
            this.row = row
            this.column = column
        },
        deleteItem() {
            // var that = this
            var val = this.selectedData

            if (val.length > 0) {
                var varIds = []
                val.forEach((item) => {
                    varIds.push(item.id)
                })
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url:
                                    "/ypt/admin/housingRegistration/info/deleteById",
                                method: "POST",
                                data: { id: varIds.toString() },
                            })
                        })
                    })
                    .then(() => {
                        this.$message({
                            type: "success",
                            message: res.message,
                        })
                    })
                this.reset()
            } else {
                this.$confirm("请选择要删除的项。", "提示")
            }
            this.$refs.multipleTable.clearSelection()
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.table_title {
    margin-top: 15px !important;
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 12px;
    padding: 0 17px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>